module.exports = __webpack_public_path__ + "media/images/front/icon_gallery_close-c601d1332bd055964769c3cd2f5fd395.svg";